/**
 * TrustArc Event Generation - See GTM Integration Guide for details.
 **/

/**
 * Map of previously dispatched preference levels
 **/
var __dispatched__ = {};

/** 
 * First step is to register with the CM API to receive callbacks when a preference update occurs.
 * You must wait for the CM API (PrivacyManagerAPI object) to exist on the page before registering. 
 **/
var __i__ = self.postMessage &&
            setInterval(function () {
                if (self.PrivacyManagerAPI && __i__) { 
                    var apiObject = {
                        PrivacyManagerAPI: {
                            action: "getConsentDecision", 
                            timestamp: new Date().getTime(),
                            self: self.location.host
                        }
                    }; 
                    self.top.postMessage(JSON.stringify(apiObject), "*");
                    __i__ = clearInterval(__i__);
                }
            }, 50);

/**
 * Callbacks will occur in the form of a PostMessage event.
 * This code listens for the appropriately formatted PostMessage event,
 * gets the new consent decision, and then pushes the events into the GTM framework.
 * Once the event is submitted, that consent decision is marked in the 'dispatched' map so it does not occur more than once. 
 **/
self.addEventListener("message", function (e, d) {
    try {
        if (e.data && (d = JSON.parse(e.data)) &&
            (d = d.PrivacyManagerAPI) && d.capabilities &&
            d.action == "getConsentDecision") {
            var newDecision =
                self.PrivacyManagerAPI.callApi("getGDPRConsentDecision", self.location.host).consentDecision;
            newDecision && newDecision.forEach(function (label) {
                if (!__dispatched__[label]) {
                    self.dataLayer && self.dataLayer.push({ "event": "GDPR Pref Allows " + label });
                    __dispatched__[label] = 1;
                }
            });
        }
    }
    catch (xx) {/* not a cm api message */}
}); 

(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.trustarc = window.oneadvanced.trustarc || {};

    ///
    // Run once code which uses functional cookies
    // to work has been approved by TrustArc.
    // also cleans up by removing event listeners.
    // if user has changed their preferences they
    // will need to reload the page in order
    // for it to take effect
    ///
    window.oneadvanced.trustarc.launchCode = function () {
        window.oneadvanced.trustarc.enableWistiaTracking();
        window.oneadvanced.trustarc.cleanUp();
    }

    ///
    // getCookieValue: - https://stackoverflow.com/questions/10730362/get-cookie-by-name
    // Searches by cookie name
    // @param: string name
    // @return: cookie value if found, otherwise returns null
    ///
    function getCookieValueByName(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }

    ///
    // handle Wistia - GDPR is enabled by default
    // as per our account settings
    // here we provide extra configuration if a user has consented
    // to functional tracking
    ///
    window.oneadvanced.trustarc.enableWistiaTracking = function () {
        window._wq = window._wq || [];
        window._wq.push(function (W) {
            var inPrivacyMode = W.consent();
            if (inPrivacyMode) {
                W.consent(true);
            }
        });
    }

    ///
    // Clean up by removing event listeners
    ///
    window.oneadvanced.trustarc.cleanUp = function () {
        window.removeEventListener("message", window.oneadvanced.trustarc.messageHandler, false);
        window.removeEventListener("unprovisioned", window.oneadvanced.trustarc.messageHandler, false);
    }

    ///
    // handle any and all messages recieved
    // checks event.type and handles either 'message' or 'unprovisioned'
    // 'unprovisioned': user is from country excempt from Cookie Policy
    // 'message': check origin for security purposes, if from TrustArc listen for
    // the user submitting their preferences. If the preference contains the value of '1'
    // then the user has accepted functional cookies and code using these can be called.
    // if not then clean up the event listeners and do not call launchCode()
    ///
    window.oneadvanced.trustarc.messageHandler = function(e) {
        if (e &&
            e.type === "unprovisioned") {
            window.oneadvanced.trustarc.launchCode();
        } else if (e &&
                   e.origin === "https://consent-pref.trustarc.com") {
                        var response = JSON.parse(e.data);
                        if (response &&
                            response.source === "preference_manager" &&
                            response.data &&
                            response.message === "submit_preferences") {
                                if (response.data.indexOf("1") !== -1) {
                                    window.oneadvanced.trustarc.launchCode();
                                } else {
                                    window.oneadvanced.trustarc.cleanUp();
                                }
                        }
        }
    }

    ///
    // Main Logic:
    // check to see if consent has already been given
    // by way of the cmapi_cookie_privacy cookie being present and
    // the value containing the string "2"
    // which indicates functional cookies
    // or if notice_behaviour cookie is present and is none which indicates that the
    // user is from an excempt country
    // if so, call launchCode(), otherwise hook up eventListeners to 
    // handle messages from TrustArc local API
    ///
    var consent_level = getCookieValueByName("cmapi_cookie_privacy");
    var notice_behaviour = getCookieValueByName("notice_behavior");
    if (consent_level &&
        consent_level.indexOf("2") !== -1 &&
        notice_behaviour &&
        notice_behaviour.indexOf("none") == -1) {
        window.oneadvanced.trustarc.launchCode();
    } else {
        window.addEventListener("message", window.oneadvanced.trustarc.messageHandler, false);
        window.addEventListener("unprovisioned", window.oneadvanced.trustarc.messageHandler, false);
    }
})();